import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';
import { InfoContratoUsuarioDTO } from '../../models/info-contrato-usuario/info-contrato-usuario.model';
import { ValidacionContratoDTO, ValidacionContratoResponse } from '../../models/validacion-contrato/validacion-contrato.model';
import { ValidacionContratoUserDTO, ValidacionContratoUserResponse } from '../../models/validacion-contrato-user/validacion-contrato-user';
@Injectable({
  providedIn: 'root',
})
export class ValidacionContratoService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.INFORMACION_CONTRATO_USER}`;
  private validacionContratoUrl = `${ENV.HOST}${URL_MAP.API.VALIDACION_CONTRATO}`;
  private validacionContratoUserUrl = `${ENV.HOST}${URL_MAP.API.VALIDACION_CONTRATO_USER}`;

  constructor(private http: HttpClient) {}

  getInfoContratoUser(
    prm_contrato: string,
  ): Observable<InfoContratoUsuarioDTO[]> {
    const body = {
      jsonParametros: JSON.stringify({ prm_contrato }),
    };

    return this.http.post<InfoContratoUsuarioDTO[]>(this.apiUrl, body);
  }

  validarContrato(prm_contrato: string): Observable<ValidacionContratoDTO[]> {
    const body = {
      jsonParametros: JSON.stringify({
        prm_contrato,
      }),
    };

    return this.http
      .post<ValidacionContratoResponse[]>(this.validacionContratoUrl, body)
      .pipe(
        map((response) =>
          response.map((item) => ({
            numeroContrato: item.numero_contrato,
            fechaValidacion: item.fecha_validacion,

            acuerdoPago: item.Acuerdo_pago,
            valorAcuerdoPago: item.Valor_acuerdo_pago,

            moraContrato: item.Mora_contrato,
            valorMoraContrato: item.Valor_mora_contrato,

            contratoInhabilitado: item.Contrato_inhabilitado,
            campaniaVigente: item.Campania_vigente,
            descripcionCampania: item.Descripcion_campania,

            prontoPagoVigente: item.pronto_pago_vigente,
          })),
        ),
      );
  }

  validarContratoUser(
    prm_docu_tipo: string,
    prm_docu_nro: string,
    prm_contrato: string,
  ): Observable<ValidacionContratoUserDTO[]> {
    const body = {
      jsonParametros: JSON.stringify({
        prm_docu_tipo,
        prm_docu_nro,
        prm_contrato,
      }),
    };

    return this.http
      .post<
        ValidacionContratoUserResponse[]
      >(this.validacionContratoUserUrl, body)
      .pipe(
        map((response) =>
          response.map((item) => ({
            tipoIdentificacion: item.tipo_identificacion.trim(),
            numeroIdentificacion: item.numero_identificacion.trim(),
            licenciaViajeExterior: item.licencia_viaje_exterior,
            anexoCobertura: item.anexo_cobertura,
            nombreAnexo: item.nombre_anexo,
            congelamientoEdad: item.congelamiento_edad,
            asociado: item.Asociado,
          })),
        ),
      );
  }

  consultaCoincidencia(
    nombre: string,
    identificacion: string,
  ): Observable<any> {
    const url = `${ENV.HOST}${URL_MAP.API.CONSULTA_COINCIDENCIA}`;
    const token = URL_MAP.TOKEN_SARLAFT || '';
    const usuario = 'Oficina Asesor';
    const params = new HttpParams()
      .set('Autorizacion', token)
      .set('Nombre', nombre ?? '')
      .set('Identificacion', identificacion ?? '')
      .set('Usuario', usuario);

    return this.http.get<any>(url, { params });
  }
}
